import AddCircleIcon from '@mui/icons-material/AddCircle';
function IconWithButton({text}){
    return(
        <>
            <div style={{zIndex:10}} class="flex-container">
            {/* <div style={{borderRadius:'3px',paddingLeft:'5px', backgroundColor:'#f51fa6'}}></div> */}
            <div><AddCircleIcon color="primary" fontSize="inherit"/></div>
            <button onClick={()=>{}} style={{zIndex:10}}class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"> {text}</button>
            </div>
        </>
    )
}

export default IconWithButton